import { Component } from 'react';
import PropTypes from 'prop-types';

/*
 * This is a shell class for the Pager HOC, meant for paths without a component that includes Pager/Validation HOCs.
 * This component will automatically mark the path on which it is included as a completed task.
 */
class PagerButton extends Component {
  UNSAFE_componentWillMount() {
    const { onMount, location } = this.props;

    onMount(location.pathname);
  }

  render() {
    return '';
  }
}

PagerButton.propTypes = {
  onMount: PropTypes.func.isRequired
};

export default PagerButton;



// WEBPACK FOOTER //
// ../core/src/components/PagerButton/PagerButton.js